'use client';

import {
  COATING_COMPONENT,
  EDIT_PRESCRIPTION_COMPONENT,
  hasReachedLensProcessStep,
  LENS_INDEX_COMPONENT,
  LENS_TYPE_COMPONENT,
} from '@/app/_lens-components/constants';
import { useLensProcessStore } from '@/app/_lens-components/store/lens-process-store';
import { EPrescriptionType } from '@/utils/enums/goods';
import { useMemo } from 'react';

export interface UseShowLensInfoResult {
  showPrescription: boolean;
  showLens: boolean;
  showLensIndex: boolean;
  showCoating: boolean;
}

/** 按当前配镜步骤（nowComponent）控制 LensInfo 各区块是否展示 */
export function useShowLensInfo(isFrameProcess: boolean): UseShowLensInfoResult {
  const {
    prescriptionType,
    lensIndexPriceInfo,
    selectedLensIndexItem,
    selectedCoating,
    selectedAdvancedLensIndexItem,
    selectedLensType,
    selectedBrand,
    nowComponent,
  } = useLensProcessStore();

  return useMemo(() => {
    const showPrescription =
      !isFrameProcess &&
      !!prescriptionType &&
      prescriptionType !== EPrescriptionType.READING_GLASSES &&
      hasReachedLensProcessStep(nowComponent, EDIT_PRESCRIPTION_COMPONENT);

    const showLens =
      hasReachedLensProcessStep(nowComponent, LENS_TYPE_COMPONENT) &&
      !!(
        selectedAdvancedLensIndexItem ||
        selectedLensType?.merge_brand === 2 ||
        (selectedLensType?.merge_brand === 1 && selectedBrand?.brand_name)
      ) &&
      prescriptionType !== EPrescriptionType.FRAME_ONLY;

    const showLensIndex =
      hasReachedLensProcessStep(nowComponent, LENS_INDEX_COMPONENT) &&
      !!selectedLensIndexItem &&
      !!lensIndexPriceInfo;

    const showCoating =
      hasReachedLensProcessStep(nowComponent, COATING_COMPONENT) && !!selectedCoating;

    return { showPrescription, showLens, showLensIndex, showCoating };
  }, [
    isFrameProcess,
    prescriptionType,
    nowComponent,
    selectedAdvancedLensIndexItem,
    selectedLensType,
    selectedBrand,
    selectedLensIndexItem,
    lensIndexPriceInfo,
    selectedCoating,
  ]);
}
